import { attributes, type } from "@type-r/models";

export type Component = InstanceType<typeof Component>;
export const Component = attributes({
    lineItemNumber : type(Number).value(0),
    partNumber : String,
    description : String,
    quantity : type(Number).value(0),
    quantityUnit : String,
    unitPrice : type(Number).value(0),
    totalValue : type(Number).value(0)
})